import { render } from "./BranchLevelSettings.vue?vue&type=template&id=2ba13262&scoped=true"
import script from "./BranchLevelSettings.vue?vue&type=script&lang=js"
export * from "./BranchLevelSettings.vue?vue&type=script&lang=js"

import "./BranchLevelSettings.vue?vue&type=style&index=0&id=2ba13262&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba13262"]])

export default __exports__